import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap, catchError, of } from 'rxjs';
import { AuthService } from '@foxera/shared/services/auth.service';
import { LocalStorageService } from '@foxera/shared/services/local-storage.service';
import { TokenService } from '@foxera/shared/services/token.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  private authService = inject(AuthService);
  private localStorageService = inject(LocalStorageService);
  private tokenService = inject(TokenService);

  private _isLoggingOut = signal(false);
  public readonly isLoggingOut = this._isLoggingOut.asReadonly();

  logout(): void {
    const userInfo = this.tokenService.getStoredUserInfo();
    const userId = userInfo?.sub;

    if (!userId || this._isLoggingOut()) {
      return;
    }

    this._isLoggingOut.set(true);

    this.authService.logout(userId).subscribe({
      next: () => {
        this.localStorageService.clear();
        this._isLoggingOut.set(false);
        window.location.reload();
      },
      error: () => {
        this._isLoggingOut.set(false);
      },
    });
  }
}
